import { render } from "./MedicalQueue.vue?vue&type=template&id=1fe558ce"
import script from "./MedicalQueue.vue?vue&type=script&lang=js"
export * from "./MedicalQueue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__